import React from 'react';
import { Item, Dot, Title, DateLabel } from './NewsListItem.styled';

export interface NewsListItemProps {
  title: string;
  dateLabel: string;
  onClick?: () => void;
}

export default function NewsListItem({ title, dateLabel, onClick }: NewsListItemProps) {
  return (
    <Item
      clickable={Boolean(onClick)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={event => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <Dot />
      <Title>{title}</Title>
      <DateLabel>{dateLabel}</DateLabel>
    </Item>
  );
}
